module.exports = __webpack_public_path__ + "img/9.c57011d3.svg";